import React from "react";

import { SvgIconProps } from "./types";

export const SvgIcon: React.FC<SvgIconProps> = (props) => {
  const { src, width, height } = props;

  return <img src={src} width={width} height={height} />;
};
